export const _setStudentScores = (state, action) => action.payload;
